var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip.left.viewport",value:(_vm.labelsList),expression:"labelsList",modifiers:{"left":true,"viewport":true}}],staticClass:"sidebar-collapsed-icon",on:{"click":_vm.handleClick}},[_c('gl-icon',{attrs:{"name":"labels"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.labels.length))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }